import PropTypes from 'prop-types'

const ToggleWithText = ({ text, color, isChecked, isDisabled, onChange }) => {
  const handleToggle = (e) => {
    e.stopPropagation()
    if (!isDisabled) onChange((prevState) => !prevState)
  }

  const backgroundColor = isChecked ? color || '#ADC9FF' : '#C4C4C4'

  return (
    <div className="toggle-switch" onClick={handleToggle}>
      <div className={`toggle-knob ${isChecked ? 'on' : 'off'}`} />
      <div className={`toggle-text ${isChecked ? 'on' : 'off'}`}>{text}</div>
      <div className="toggle-background" style={{ backgroundColor }} />
    </div>
  )
}

ToggleWithText.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ToggleWithText
